document.addEventListener("DOMContentLoaded", function () {
  const counters = document.querySelectorAll(".animated-counter");

  const options = {
    threshold: 0.6,
  };

  const animateCount = (el) => {
    const target = +el.getAttribute("data-target");
    let count = 0;
    const duration = 1500; // tiempo total en milisegundos
    const increment = target / (duration / 16); // 60fps

    const update = () => {
      count += increment;
      if (count < target) {
        el.textContent = Math.floor(count);
        requestAnimationFrame(update);
      } else {
        el.textContent = target.toLocaleString(); // para mostrar comas
      }
    };

    el.textContent = "0"; // reinicia antes de contar
    update();
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        animateCount(entry.target);
      }
    });
  }, options);

  counters.forEach((counter) => {
    observer.observe(counter);
  });
});
